import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { PRESENCE } from '../../utils/constants';
import cssStyles from './Contacts.css';
import UserContext from './UserContext';

const presenceClassMap = {};
presenceClassMap[PRESENCE.UNKNOWN] = 'presence-avatar--unknown';
presenceClassMap[PRESENCE.ONLINE] = 'presence-avatar--online';
presenceClassMap[PRESENCE.AWAY] = 'presence-avatar--away';
presenceClassMap[PRESENCE.OFFLINE] = 'presence-avatar--offline';

function Buddy({ contact, changeConversation }) {
  const presenceClass = `presence--${contact.presence}` || PRESENCE.UNKNOWN;
  const classes = cssStyles[presenceClass];
  return (
    <div
      role='menuitem'
      tabIndex={0}
      onKeyDown={() => {}}
      onClick={() => {
        changeConversation(contact);
      }}
      className={cssStyles.contact_container}
    >
      <div className={cssStyles.contact_info}>
        <div className={cssStyles.contact}>
          <div className={cssStyles.roster_image_container}>
            <img
              alt={contact.name}
              className={cssStyles.roster_image}
              src={contact.imageUrl}
            />
            <div className={classNames(classes, cssStyles.presence)}> </div>
          </div>
          <span className={cssStyles.roster_label}>{contact.name}</span>
        </div>
        <div className={cssStyles.actions}>
          <UserContext
            userInfo={contact}
            changeConversation={changeConversation}
          />
        </div>
      </div>
    </div>
  );
}

Buddy.propTypes = {
  contact: PropTypes.object.isRequired,
  changeConversation: PropTypes.func.isRequired,
};

export default Buddy;



// WEBPACK FOOTER //
// ./src/components/roster/Buddy.js